__turbopack_context__.v({
  "cbpSpin": "cookbook-picker-module__3zqEoa__cbpSpin",
  "checkbox": "cookbook-picker-module__3zqEoa__checkbox",
  "closeBtn": "cookbook-picker-module__3zqEoa__closeBtn",
  "createActions": "cookbook-picker-module__3zqEoa__createActions",
  "createForm": "cookbook-picker-module__3zqEoa__createForm",
  "emptyText": "cookbook-picker-module__3zqEoa__emptyText",
  "error": "cookbook-picker-module__3zqEoa__error",
  "footer": "cookbook-picker-module__3zqEoa__footer",
  "header": "cookbook-picker-module__3zqEoa__header",
  "headerTitle": "cookbook-picker-module__3zqEoa__headerTitle",
  "list": "cookbook-picker-module__3zqEoa__list",
  "name": "cookbook-picker-module__3zqEoa__name",
  "newBtn": "cookbook-picker-module__3zqEoa__newBtn",
  "popover": "cookbook-picker-module__3zqEoa__popover",
  "row": "cookbook-picker-module__3zqEoa__row",
  "scrim": "cookbook-picker-module__3zqEoa__scrim",
  "scrollArea": "cookbook-picker-module__3zqEoa__scrollArea",
  "spinner": "cookbook-picker-module__3zqEoa__spinner",
});
